<script lang="ts" generics="T extends { id: number }">
  import { type Snippet } from "svelte"

  interface Props {
    items: T[]
    field: string
    displayField: string
    inputClass: string
    ulClass: string
    minChars: number
    inputValue: string
    placeholder: string
    filterFn?: (val: string) => T[]
    onselected?: (val: string) => void
    onchange?: (val: string) => void
    itemsnippet?: Snippet<T>
    onfocus?: (input: HTMLInputElement) => void
    onblur?: (val: string) => void
  }

  let props = $props()

  let {
    items = [],
    field = "name",
    displayField = "label",
    minChars = 1,
    inputClass = "",
    ulClass = "",
    placeholder = "",
    filterFn = (val: string) => {
      return items.filter((item) => {
        return item[field].toLowerCase().includes(val.toLowerCase())
      })
    },
    onselected,
    onchange,
    itemsnippet,
    onfocus,
    onblur
  }: Props = props
  let inputValue = $state(props.inputValue || "")

  let filteredItems: T[] = $state([])
  let focused = $state(false)
  let activeIndex = $state(0)
  if (minChars === 0) filteredItems = [...items]

  async function filterData(): Promise<void> {
    if (inputValue.trim().length < minChars) {
      return
    }
    try {
      filteredItems = await filterFn(inputValue)
    } catch (e) {}
  }

  function moveIndex(e): void {
    switch (e.key) {
      case "ArrowDown":
        activeIndex++
        break
      case "ArrowUp":
        activeIndex--
        break
      case "Enter":
        if (filteredItems[activeIndex]) {
          emitSelected(filteredItems[activeIndex])
        } else {
          emitSelected(inputValue)
        }
        break
      case "Escape":
        inputValue = ""
        focused = false
        break
    }
    if (activeIndex < 0) activeIndex = filteredItems.length - 1
    if (activeIndex >= filteredItems.length) activeIndex = 0
  }

  let blurActive = true

  function emitSelected(item: any): void {
    setTimeout(() => (blurActive = false), 200)
    onselected(item)
    inputValue = item.name
    focused = false
  }

  /* HANDLING THE INPUT */
  let searchInput: HTMLInputElement // use with bind:this to focus element
</script>

<div class="w-full autocomplete-container">
  <div class="relative">
    <input
      type="text"
      class="input-admin w-full {inputClass || ''}"
      {placeholder}
      autocomplete="off"
      bind:this={searchInput}
      bind:value={inputValue}
      oninput={filterData}
      onkeyup={moveIndex}
      onfocus={() => {
        focused = true
        if (onfocus) {
          onfocus(searchInput)
        }
      }}
      onclick={() => {
        focused = true
        if (onfocus) {
          onfocus(searchInput)
        }
      }}
      onchange={() => onchange(inputValue)}
      onblur={() => {
        if (!blurActive) return
        focused = false
        if (onblur) {
          onblur(inputValue)
        }
      }}
    />
  </div>

  <div class="relative">
    {#if filteredItems.length > 0}
      <ul
        class:hidden={!focused}
        data-name="autocomplete-items"
        class="absolute top-0 border text-left w-full bg-white overflow-auto {ulClass ||
          ''}}"
      >
        {#each filteredItems as item, idx}
          <li class="cursor-pointer" class:bg-blue-200={activeIndex === idx}>
            <div
              role="button"
              tabindex={idx + 4}
              data-name="autocomplete-item"
              onmouseenter={() => (activeIndex = idx)}
              onmousedown={() => emitSelected(item)}
            >
              {#if itemsnippet}
                {@render itemsnippet(item)}
              {:else}
                <div class="px-4 py-2">
                  {item[displayField]}
                </div>
              {/if}
            </div>
          </li>
        {/each}
      </ul>
    {/if}
  </div>
</div>

<style>
  ul {
    max-height: 400px;
    z-index: 1000;
  }
</style>
